export type AccessTokenOptions = {
  cacheMode?: "on" | "off" | "cache-only";
};

type GetAccessTokenSilently = (options?: AccessTokenOptions) => Promise<string>;

export default class AuthService {
  private static instance: AuthService;
  private getAccessTokenSilentlyFunction?: GetAccessTokenSilently;
  private logoutHandler?: () => void;

  public static getInstance(): AuthService {
    if (!AuthService.instance) {
      AuthService.instance = new AuthService();
    }
    return AuthService.instance;
  }

  public setAccessTokenSilentlyFunction(func: GetAccessTokenSilently): void {
    this.getAccessTokenSilentlyFunction = func;
  }

  public setLogoutHandler(func: () => void): void {
    this.logoutHandler = func;
  }

  public runLogoutHandler(): void {
    this.logoutHandler?.();
  }

  public async getUserAccessToken(options?: AccessTokenOptions): Promise<string | null> {
    if (this.getAccessTokenSilentlyFunction) {
      return await this.getAccessTokenSilentlyFunction(options);
    }
    return null;
  }
}
